import Model from './Model'

export default class FunnelAffiliate extends Model
{
    resource()
    {
        return 'funnel-affiliates'
    }
}
